"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  common: {
    organizationConfiguration: 'Organization Configuration',
    onlineUserInfo: 'Online User Info',
    serialNumber: 'Serial Number',
    operation: 'Operation',
    remark: 'Remark',
    group: 'Group',
    total: 'Total',
    btn: {
      add: 'Add',
      del: 'Del',
      fresh: 'Fresh',
      confirm: 'Confirm',
      cancel: 'Cancel',
      changeUnit: 'Change Unit',
      export: 'Export',
      import: 'Import',
      download: 'Download the Template',
      save: 'Save',
      checkAccount: 'Check the Account',
      replaceFleet: 'Replace',
      remove: 'Remove',
      addShip: 'Addship',
      specifyAccount: 'Specify Account',
      create: 'Create',
      check: 'Search',
      reset: 'Reset',
      cancelLogout: 'Cancel Logout',
      logout: 'Logout',
      ripInfo: 'Rip Info',
      close: 'Close',
      migration: 'Migration',
      copyOperationFrom: 'Clone Operation',
      insertRow: 'Insert row',
      portChange: 'Port change',
      acquirePortSpace: 'Acquire port space',
      estimate: 'Estimate',
      importPallet: 'Import pallet',
      print: 'Print',
      copyEstimate: 'Copy estimate',
      viewFormula: 'View formula',
      audit: 'Audit',
      estimateTemplate: 'Estimate template',
      paymentApplication: 'Payment Application',
      approvalProcess: 'Approval process',
      refresh: 'Refresh'
    },
    placeholder: {
      select: 'Select',
      showCancel: 'Show Cancel',
      search: 'Search',
      enterCode: 'Please enter the backlog code',
      pleaseSelect: 'Please select',
      enterContent: 'Please enter content',
      takeEffect: 'Effect',
      loseEfficacy: 'Lose Efficacy',
      pleaseEnter: 'Please Enter',
      optionDate: 'Option Date'
    },
    message: {
      hintTitle: ' Are you sure to delete the record',
      hint: 'Hint',
      successfullyDelete: 'Successfully Delete',
      failDelete: 'fail To Delete',
      changeSuccess: 'Change Success',
      saveSuccessfully: 'Save Successfully',
      newSuccess: 'Newsuccess',
      updateSuccessfully: 'Update Successfully',
      message1: 'Select the organization to delete',
      message2: 'Please select the organization that you want to change the parent organization',
      message3: 'Please select the parent organization to change',
      message4: 'Names of ships must not be empty',
      message5: 'Please select the fleet to delete',
      message6: 'Please save the fleet information first',
      message7: 'Please select ship',
      message8: 'Existing, remaining saved successfully',
      message9: 'Please select the ship you want to remove',
      message10: 'Please select the ship to be replaced',
      message11: 'Successful fleet replacement',
      message12: 'Change fleet successfully please check at least one ship data',
      message13: 'Please select the account number',
      message14: 'Designated account successful',
      message15: 'Please select the record where you want to change the time',
      message16: 'Please select a start time',
      message17: 'Please choose a new fleet',
      message18: 'Please select to check at least ',
      message19: 'Please generate at least one record',
      message20: 'Select the record you want to delete',
      message21: 'Change the time successfully',
      message22: 'operate successfully',
      message23: 'Operation failure',
      message24: 'Do you want to delete this configuration or continue?',
      message25: 'The end time cannot be less than the beginning time',
      message26: 'The role cannot be empty',
      message27: 'Cancel logout successfully',
      message28: 'Determine whether to generate internal supplier information?',
      message29: 'Please select the account you want to delete',
      message30: 'Please select the account for which you want to migrate the organization',
      message31: 'Select migrate organization',
      message32: 'Please select the row you wang to insert',
      message34: 'Please select the rows to be merged',
      message35: 'Please tick the data you want to delete',
      message36: 'Please select the organization that the broker wants to delete',
      message37: 'Please select the data that exceeds the inventory to be deleted',
      message38: 'Please select the data to delete from the inventory information',
      message39: 'Only one piece of data can be checked',
      alreadyExist: 'Already Exist',
      yes: 'Yes',
      no: 'No',
      generateSuccess: 'Generate Success',
      cancellationSuccess: 'Cancellation of success',
      continue: 'continue',
      successfulMigration: 'Successful Migration'
    },
    examine: {
      rules1: 'Please enter the organization code',
      rules2: 'The length is between 1 and 50 characters',
      rules3: 'Please enter the organization name',
      rules4: 'The length is between 1 and 200 characters',
      rules5: 'Please select a country/region',
      rules6: 'Please select the organization type'
    }
  },
  // 代办配置管理
  workConfig: {
    backlogConfigurationManagement: 'Backlogconfiguration Management',
    taskCode: 'Task Code',
    taskSummaryType: 'Task Type',
    taskName: 'Task Name',
    taskName2: 'Task Name',
    taskName3: 'Company Name',
    taskType: 'Task Classification',
    activeDate: 'Valid From',
    invalidDate: 'Expiration Date',
    taskNameCn: 'Custom Task Name(CN)',
    taskNameEn: 'Custom Task Name(EN)',
    validFlag: 'Status',
    newBacklogConfiguration: 'Newbacklog Configuration',
    backlogConfigurationDetails: 'Backlog Configuration Details',
    examineApprove: 'Examine and Approve',
    name: 'Name',
    systematicName: 'Systematic Name'
  },
  // 消息提醒配置
  msgRemindConfig: {
    messageConfiguration: 'messageConfiguration',
    company: 'Company',
    dept: 'Department',
    role: 'Role',
    user: 'User',
    postRoleFlag: 'Applicable Roles',
    applyType: 'Range of Application',
    applyObject: 'Apply Object',
    postRoleFlag1: 'Applicable Oost Role',
    customFlag: 'Custom Configuration',
    meaasgeMode: 'Message Module',
    messageType: 'Message Type',
    subTypeValue: 'Message Subtype',
    manualFlag: 'Manually Mark Read',
    customConfiguration: 'Custom configuration',
    newMessageConfiguration: 'Newmessage Configuration',
    messageDetails: 'Message Details',
    hcbCode: 'HCB Code'
  },
  // 登录日志
  loginLogs: {
    loginTime: 'Login Time',
    loginName: 'Login Name',
    userName: 'User Name',
    IP: 'Ip',
    usrCode: 'User Code',
    accountCode: 'Account Code',
    companyName: 'Company Name',
    officeName: 'Dept Name',
    roleName: 'Role Name',
    browser: 'Browser',
    os: 'Os',
    isSuccess: 'Login Success',
    createTime: 'Login Time',
    searchByIp: 'Search by IP',
    loginLogs: 'Login Logs',
    transferTodo: 'Transfer Todo',
    confirmTransferTodo: 'Confirm Transfer',
    transfer: 'Transfer',
    transferAll: 'Transfer All',
    transferOnlyOne: 'Please select one to transfer for todo task',
    notSelf: 'The transferor and the transferee cannot be the same person',
    onlyOne: 'Only one message can be checked to view the login log',
    lessOne: 'less One row needs to be selected.',
    pickUser: 'Pick user'
  }
};